import { differenceInCalendarDays, parseISO, startOfDay } from 'date-fns'
import type { TareaCompleta } from '@/types/database'

export type ClasificacionTemporal =
  | 'urgente'
  | 'vencida'
  | 'hoy'
  | 'esta_semana'
  | 'este_mes'
  | 'sin_fecha'
  | 'completada'

interface ClasificarTemporalOpts {
  /**
   * When true (Kanban default), tareas with prioridad 'urgente' short-circuit
   * to the 'urgente' bucket regardless of fecha_limite. The panel de inicio
   * disables it to group strictly by date.
   */
  priorizarUrgente?: boolean
}

export const clasificarTemporal = (
  tarea: TareaCompleta,
  { priorizarUrgente = true }: ClasificarTemporalOpts = {}
): ClasificacionTemporal => {
  if (tarea.estado === 'completada') return 'completada'
  if (priorizarUrgente && tarea.prioridad === 'urgente') return 'urgente'
  if (!tarea.fecha_limite) return 'sin_fecha'
  const hoy = startOfDay(new Date())
  const fecha = startOfDay(parseISO(tarea.fecha_limite))
  const dias = differenceInCalendarDays(fecha, hoy)
  if (dias < 0) return 'vencida'
  if (dias === 0) return 'hoy'
  if (dias <= 7) return 'esta_semana'
  return 'este_mes'
}
